import { useState } from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/form/Button";
import type { ButtonHTMLAttributes, PropsWithChildren } from "react";
import type { ButtonVariantsProps } from "@/components/form/buttonVariants";

type Props = ButtonHTMLAttributes<HTMLButtonElement> &
    ButtonVariantsProps &
    PropsWithChildren & {
    className?: string;
    duration?: number; // seconds
};

export function LoaderButton({ duration=5, children, className, ...props }: Props) {
    const [phase, setPhase] = useState<"filling" | "fading" | "done">("filling");

    return (
        <Button
            disabled={phase !== "done"}
            className={`relative overflow-hidden shrink-0 ${className ?? ""}`}
            {...props}
        >
            {phase !== "done" && (
                <motion.div
                    className="absolute inset-0 bg-white/20 z-0"
                    initial={{ width: "0%", opacity: 1 }}
                    animate={
                        phase === "filling"
                            ? { width: "100%", opacity: 1 }
                            : { opacity: 0 }
                    }
                    transition={
                        phase === "filling"
                            ? { duration, ease: "linear" }
                            : { duration: 0.3, ease: "easeOut" }
                    }
                    onAnimationComplete={() => {
                        if (phase === "filling") setPhase("fading");
                        else if (phase === "fading") setPhase("done");
                    }}
                />
            )}
            <span className="relative z-10 flex items-center justify-center h-full w-full">{children}</span>
        </Button>
    );
}

export default LoaderButton;